<template>
    <div id="coupon">
        <p style="padding:0.5rem 0.5rem 0;color:#666;">此订单不可用的券 ({{couponList.length}}张)</p>
        <coupon v-for="item in couponList" :key="item.id" :coupon="item" is-invalid/>
    </div>
</template>

<script>
import coupon from "../../components/Coupon.vue";
export default {
  name: "Coupon",
  data() {
    return {
      couponList: []
    };
  },
  components: {
    coupon
  },
  created() {
    this.getCoupon();
  },
  methods: {
    getCoupon() {
      let params = {
        params: { flag: 1 }
      };
      this.$axios.post("coupon/getbyownerId", params).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data;
          this.couponList = data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#coupon {
}
</style>
